import { BeanPrimaryEntity } from "../../bean-primary-entity";
import { Contacts } from "../../contact/save/contacts";
import { AssetsPipesAssociated } from "./assets-pipes-associateds";
import { PipelinesLTSAContactInfo } from "./pipeline-ltsa-contact-info";
import { PipelinesLTSASubTypes } from "./pipeline-ltsa-sub-types";
import { PipelinesLTSATrades } from "./pipeline-ltsa-trades";
import { PipelinesLTSATypes } from "./pipeline-ltsa-types";

export class PipelinesLTSA extends BeanPrimaryEntity {
    pipelineLtsaId: number;
    ltsaStatusId: string | null;
    companyId: number;
    contractLength: string;
    contractExpiration: Date | null;
    contractExpirationResolution: string | null;
    preferredContractor: string;
    comments: string;

    pipelinesLtsaContactInfo: Array<PipelinesLTSAContactInfo>;
    pipelinesLtsaTypes: Array<PipelinesLTSATypes>;
    pipelinesLtsaSubTypes: Array<PipelinesLTSASubTypes>;
    pipelinesLtsaTrades: Array<PipelinesLTSATrades>;
    assetsPipesAssociated: Array<AssetsPipesAssociated>;
    contacts: Array<Contacts>;

    constructor(entity?: any) {
        super(entity);
        this.pipelineLtsaId = entity?.pipelineLtsaId ?? null;
        this.ltsaStatusId = entity?.ltsaStatusId ?? null;
        this.companyId = entity?.companyId ?? null;
        this.contractLength = entity?.contractLength ?? '';
        this.contractExpiration = entity?.contractExpiration ?? null;
        this.contractExpirationResolution = entity?.contractExpirationResolution ?? null;
        this.preferredContractor = entity?.preferredContractor ?? '';
        this.comments = entity?.comments ?? '';

        this.pipelinesLtsaContactInfo = entity?.pipelinesLtsaContactInfo ?? [];
        this.pipelinesLtsaTypes = entity?.pipelinesLtsaTypes ?? [];
        this.pipelinesLtsaSubTypes = entity?.pipelinesLtsaSubTypes ?? [];
        this.pipelinesLtsaTrades = entity?.pipelinesLtsaTrades ?? [];
        this.assetsPipesAssociated = entity?.assetsPipesAssociated ?? [];
        this.contacts = entity?.contacts ?? [];

    }


}

